'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleSaga = titleSaga;

var _reduxSaga = require('redux-saga');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _data = require('../constants/data');

var _actionTypes = require('../constants/actionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [titleSaga].map(regeneratorRuntime.mark);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
/* injects from baggage-loader */

function setTitle(title) {
  document.title = 'Metapro - ' + title;
}

function titleSaga(getState) {
  var state, foreignUser, data, project, user, node;
  return regeneratorRuntime.wrap(function titleSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 24;
            break;
          }

          _context.next = 3;
          return (0, _reduxSaga.take)([].concat(_toConsumableArray(_actionTypes.ROUTING_ACTIONS_KEYS), [_actionTypes.SET_AUTHORIZED_USER, _actionTypes.SET_SHOWN_USER, _actionTypes.SET_PROJECT, _actionTypes.SET_EDITOR_NODE]));

        case 3:
          state = getState();
          foreignUser = state.routing.foreignUser;
          data = state.routing.meta.data;
          project = state.projects.project;
          user = foreignUser ? state.user.showUser : state.user.authorizedUser;
          node = state.nodes.editorNode;

          if (!(_lodash2.default.isEqual(data, [_data.PROJECTS_DATA]) && user)) {
            _context.next = 14;
            break;
          }

          _context.next = 12;
          return (0, _reduxSaga.call)(setTitle, user.displayName + ' projects');

        case 12:
          _context.next = 22;
          break;

        case 14:
          if (!(_lodash2.default.isEqual(data, [_data.PROJECT_DATA]) && project)) {
            _context.next = 19;
            break;
          }

          _context.next = 17;
          return (0, _reduxSaga.call)(setTitle, project.name);

        case 17:
          _context.next = 22;
          break;

        case 19:
          if (!(_lodash2.default.isEqual(data, [_data.NODE_DATA]) && node)) {
            _context.next = 22;
            break;
          }

          _context.next = 22;
          return (0, _reduxSaga.call)(setTitle, node.caption);

        case 22:
          _context.next = 0;
          break;

        case 24:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
}


//////////////////
// WEBPACK FOOTER
// ./app/sagas/title.js
// module id = 637
// module chunks = 1